import { Link } from "react-router-dom";

const SelectCarrierAction = () => {
  return <Link to="/app/carriers">Select one</Link>;
};

export default SelectCarrierAction;
